import React, { useState, useEffect } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Typography, Divider } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import { Controller } from 'react-hook-form';
import TextField from '@material-ui/core/TextField';
import * as emailValidator from 'email-validator';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles as makeStyles$1 } from '@material-ui/styles';
import NumberFormat from 'react-number-format';
import MaskedInput from 'react-text-mask';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Route, Redirect, Link } from 'react-router-dom';
import clsx from 'clsx';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Drawer from '@material-ui/core/Drawer';
import Divider$1 from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Typography$1 from '@material-ui/core/Typography';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import LinearProgress from '@material-ui/core/LinearProgress';

var useStyles$9 = makeStyles(function (theme) { return ({
    content: {
        flexGrow: 1,
    },
}); });
var Content = function (_a) {
    var children = _a.children;
    var classes = useStyles$9();
    return (React.createElement(React.Fragment, null,
        React.createElement("main", { className: classes.content }, children)));
};

var useStyles$8 = makeStyles(function (theme) { return ({
    container: {
        padding: theme.spacing(2)
    },
    content: {
        marginTop: theme.spacing(3)
    },
    title: {
        color: theme.palette.text.primary
    }
}); });
var Page = function (_a) {
    var title = _a.title, children = _a.children;
    var classes = useStyles$8();
    return (React.createElement("div", { className: classes.container },
        React.createElement(Typography, { variant: "h5", className: classes.title }, title),
        React.createElement(Divider, null),
        React.createElement("div", { className: classes.content }, children)));
};

var useStyles$7 = makeStyles(function (theme) { return ({
    root: {
        padding: 0,
        display: 'flex',
    }
}); });
var Root = function (_a) {
    var children = _a.children;
    var classes = useStyles$7();
    return (React.createElement(Container, { maxWidth: false, className: classes.root }, children));
};

var useStyles$6 = makeStyles(function (theme) { return ({
    root: {
        margin: theme.spacing(1),
        padding: 0,
        minHeight: "95vh",
        width: "99%" //Stop horizontal size from overflowing
    },
    lockHeight: {
        height: "95vh",
        overflow: "hidden",
    }
}); });
var PaperPage = function (_a) {
    var className = _a.className, lockHeight = _a.lockHeight, children = _a.children;
    var classes = useStyles$6();
    return (React.createElement(Paper, { elevation: 1, variant: "outlined", className: (className ? className : "") + " " + classes.root + " " + (lockHeight ? classes.lockHeight : "") }, children));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function isEmail(email) {
    return emailValidator.validate(email) || email === "" ? undefined : "Email is invalid";
}

var EmailInput = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled"]);
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : "", rules: Object.assign(rules ? rules : {}, { validate: {
                isEmail: isEmail
            } }), render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(TextField, __assign({}, field, rest, { label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, margin: "dense", fullWidth: true, variant: "outlined", disabled: disabled, InputLabelProps: {
                    disableAnimation: true
                } }));
        } }));
};

var FormCheckbox = function (_a) {
    var name = _a.name, control = _a.control, label = _a.label, defaultValue = _a.defaultValue, rules = _a.rules, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "label", "defaultValue", "rules", "disabled"]);
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue !== undefined ? defaultValue : false, rules: rules, render: function (_a) {
            var field = _a.field;
            return React.createElement(FormControlLabel, __assign({ label: label }, field, { checked: field.value === true, control: React.createElement(Checkbox, __assign({ color: "primary", disabled: disabled }, rest, { disableRipple: true })) }));
        } }));
};

var FormTextField$1 = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled"]);
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : "", rules: rules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(TextField, __assign({}, field, rest, { onChange: function (e) {
                    if (/^[0-9]*$/.test(e.target.value))
                        field.onChange(e);
                }, label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, variant: "outlined", fullWidth: true, disabled: disabled, margin: "dense", InputLabelProps: {
                    disableAnimation: true
                } }));
        } }));
};

var sharedStyles = function (theme) {
    var disabledTextColor = "#495057";
    var disabledBGColor = "#E9ECEF";
    return {
        canDisable: {
            "& .MuiInputBase-root.Mui-disabled": {
                color: disabledTextColor,
                backgroundColor: disabledBGColor
            }
        }
    };
};

var useStyles$5 = makeStyles$1(function (theme) {
    return __assign({}, sharedStyles());
});
var FormSelect = function (_a) {
    var name = _a.name, control = _a.control, options = _a.options, getOptionLabel = _a.getOptionLabel, getOptionValue = _a.getOptionValue, disableWhenOne = _a.disableWhenOne, defaultValue = _a.defaultValue, label = _a.label, rules = _a.rules, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "options", "getOptionLabel", "getOptionValue", "disableWhenOne", "defaultValue", "label", "rules", "disabled"]);
    var classes = useStyles$5();
    var tryGetOptionValue = function (option) {
        if (option !== undefined)
            return getOptionValue ? getOptionValue(option) : option;
        else
            return '';
    };
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : tryGetOptionValue(options[0]), rules: rules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(TextField, __assign({}, field, rest, { className: classes.canDisable, disabled: (disableWhenOne && options.length <= 1) || disabled, select: true, label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, margin: "dense", fullWidth: true, variant: "outlined" }), options.map(function (option, index) {
                return React.createElement(MenuItem, { key: option + "_" + index, value: tryGetOptionValue(option) }, getOptionLabel ? getOptionLabel(option) : option);
            }));
        } }));
};

var useStyles$4 = makeStyles$1(function (theme) {
    var shared = sharedStyles();
    return __assign({}, shared);
});
var FormTextArea = function (_a) {
    var name = _a.name, control = _a.control, initRows = _a.initRows, label = _a.label, defaultValue = _a.defaultValue, rules = _a.rules, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "initRows", "label", "defaultValue", "rules", "disabled"]);
    var classes = useStyles$4();
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : "", rules: rules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(TextField, __assign({}, field, rest, { disabled: disabled, className: classes.canDisable, label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, rows: initRows, multiline: true, rowsMax: Infinity, margin: "dense", fullWidth: true, variant: "outlined", InputLabelProps: {
                    disableAnimation: true
                } }));
        } }));
};

var useStyles$3 = makeStyles$1(function (theme) {
    var shared = sharedStyles();
    return __assign({}, shared);
});
var FormTextField = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled"]);
    var classes = useStyles$3();
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : "", rules: rules, render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(TextField, __assign({}, field, rest, { disabled: disabled, className: classes.canDisable, label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, margin: "dense", fullWidth: true, variant: "outlined", InputLabelProps: {
                    disableAnimation: true
                } }));
        } }));
};

var useStyles$2 = makeStyles$1(function (theme) {
    var shared = sharedStyles();
    return __assign({}, shared);
});
var NoReadWriteTextField = function (_a) {
    var value = _a.value, label = _a.label, rest = __rest(_a, ["value", "label"]);
    var classes = useStyles$2();
    return (React.createElement(TextField, __assign({ className: classes.canDisable }, rest, { label: label, disabled: true, margin: "dense", fullWidth: true, variant: "outlined", value: value })));
};

var isPhone = function (phone) {
    return /^\(\d{3}\) \d{3}-\d{4}$/.test(phone) || phone === "" ? undefined : "Phone number is invalid";
};

//Formats input as phone number with format (403) 123-4567
var PhoneInput = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled"]);
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : "", rules: Object.assign(rules ? rules : {}, { validate: {
                isPhone: isPhone
            } }), render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            return React.createElement(NumberFormat, __assign({}, field, rest, { format: "(###) ###-####", mask: "_", customInput: TextField, label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, variant: "outlined", fullWidth: true, margin: "dense", disabled: disabled, InputLabelProps: {
                    disableAnimation: true
                } }));
        } }));
};

// LuhnCheck modified from ShirtlessKirk. Copyright (c) 2012.
// @license WTFPL (http://www.wtfpl.net/txt/copying)
var luhnCheck = (function (arr) {
    return function (ccNum, checkDigit) {
        var len = ccNum.length, bit = 1, sum = 0, val;
        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }
        return (10 - sum % 10) % 10 === parseInt(checkDigit);
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

function isPHN(phn) {
    //Don't show length requirement if no input detected
    if (phn === "")
        return undefined;
    var phnPat = /^\d{9}$/i;
    if (phnPat.test(phn)) {
        var fifthDigit = phn.charAt(4); //Extract 5th digit
        var ccNum = phn.slice(0, 4) + phn.slice(5, 9) + "0"; //Form string without 5th digit and a 0 appended to the end
        return luhnCheck(ccNum, fifthDigit) ? undefined : "PHN is invalid"; //Run Luhn's algorithm to calculate the check digit. If it matches the 5th digit then the PHN is valid
    }
    else
        return "PHN must be 9 digits";
}

var useStyles$1 = makeStyles$1(function (theme) {
    return __assign({}, sharedStyles());
});
var TextMaskCustom = function (props) {
    var inputRef = props.inputRef, other = __rest(props, ["inputRef"]);
    return (React.createElement(MaskedInput, __assign({}, other, { ref: function (ref) {
            inputRef(ref ? ref.inputElement : null);
        }, mask: [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/], showMask: true, guide: false })));
};
//Dropdown lookup for patient info based on PHN
//Value returned is a PatientInfo object
var PHNInput = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, ignoreChecksum = _a.ignoreChecksum, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled", "ignoreChecksum"]);
    useStyles$1();
    return (React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue, rules: Object.assign({ validate: {
                isPHN: function (phn) {
                    if (ignoreChecksum)
                        return undefined;
                    return isPHN(phn);
                }
            } }, __assign({}, rules)), render: function (_a) {
            var _b;
            var field = _a.field, fieldState = _a.fieldState;
            var inputProps = {};
            if (!ignoreChecksum) {
                inputProps.inputComponent = TextMaskCustom;
            }
            return (React.createElement(TextField, __assign({}, field, rest, { InputProps: inputProps }, { label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, onChange: function (e) {
                    var phn = e.target.value.split('-').join('');
                    field.onChange(phn);
                }, margin: "dense", fullWidth: true, variant: "outlined", disabled: disabled, InputLabelProps: {
                    disableAnimation: true
                } })));
        } }));
};

var FormDate = function (_a) {
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, rules = _a.rules, label = _a.label, disabled = _a.disabled, format = _a.format, rest = __rest(_a, ["name", "control", "defaultValue", "rules", "label", "disabled", "format"]);
    return (React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
        React.createElement(Controller, { name: name, control: control, defaultValue: defaultValue ? defaultValue : new Date(), rules: rules, render: function (_a) {
                var _b;
                var field = _a.field, fieldState = _a.fieldState;
                return React.createElement(DatePicker, __assign({}, field, rest, { label: label, error: fieldState.error !== undefined, helperText: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, onChange: function (date) {
                        if (date)
                            field.onChange(date.toDate());
                    }, variant: "inline", format: format ? format : "MMM DD, yyyy", autoOk: true, disabled: disabled, inputVariant: "outlined", margin: "dense", fullWidth: true }));
            } })));
};

var PrivateRoute = function (_a) {
    var children = _a.children, authenticated = _a.authenticated, path = _a.path, rest = __rest(_a, ["children", "authenticated", "path"]);
    return (React.createElement(Route, { path: path }, authenticated === true ? (children) : (React.createElement(Redirect, { to: { pathname: "/auth/login", state: { prevPath: rest } } }))));
};

var Sidebar = function (_a) {
    var _b, _c;
    var headerOptions = _a.headerOptions, drawerWidth = _a.drawerWidth, children = _a.children;
    //Needs to be inside component, otherwise drawerWidth variable causes rest of page not to expand when sidebar closes
    var useStyles = makeStyles(function (theme) {
        var _a;
        return ({
            drawer: {
                width: drawerWidth,
                flexShrink: 0,
                whiteSpace: 'nowrap',
            },
            drawerOpen: {
                width: drawerWidth,
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.enteringScreen,
                }),
            },
            drawerClose: (_a = {
                    transition: theme.transitions.create('width', {
                        easing: theme.transitions.easing.sharp,
                        duration: theme.transitions.duration.leavingScreen,
                    }),
                    overflowX: 'hidden',
                    width: theme.spacing(7) + 1
                },
                _a[theme.breakpoints.up('sm')] = {
                    width: theme.spacing(9) + 1,
                },
                _a),
            toolbar: __assign({ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', padding: theme.spacing(0, 1) }, theme.mixins.toolbar),
            header: {
                marginLeft: theme.spacing(2)
            },
        });
    });
    var classes = useStyles();
    var _d = useState(true), open = _d[0], setOpen = _d[1];
    var _e = useState(true), showText = _e[0], setShowText = _e[1];
    var handleDrawerOpen = function () {
        setOpen(true);
    };
    var handleDrawerClose = function () {
        setOpen(false);
    };
    useEffect(function () {
        if (open) {
            //Delay showing text so that it doesn't show up below the logo before the sidebar has time to open enough
            setTimeout(function () {
                setShowText(open);
            }, 200);
        }
        else {
            setShowText(open);
        }
    }, [open]);
    return (React.createElement(Drawer, { variant: "permanent", className: clsx(classes.drawer, (_b = {},
            _b[classes.drawerOpen] = open,
            _b[classes.drawerClose] = !open,
            _b)), classes: {
            paper: clsx((_c = {},
                _c[classes.drawerOpen] = open,
                _c[classes.drawerClose] = !open,
                _c)),
        } },
        React.createElement(List, { color: "primary" },
            !headerOptions.customHeader && (React.createElement(ListItem, null,
                React.createElement(Grid, { container: true, direction: "row", alignItems: "center" },
                    React.createElement(Grid, { item: true },
                        React.createElement("img", { src: headerOptions.headerLogoSrc, className: "img-fluid", alt: "Alethea Logo", width: "40", height: "40" })),
                    showText &&
                        React.createElement(Grid, { item: true, xs: 1 },
                            React.createElement(Fade, { in: showText },
                                React.createElement(Typography$1, { className: classes.header, variant: "h6", color: "primary" }, headerOptions.headerText)))))),
            headerOptions.customHeader && (headerOptions.customHeader),
            React.createElement(Divider$1, null),
            children),
        React.createElement(Divider$1, null),
        React.createElement("div", { className: classes.toolbar }, open ?
            React.createElement(IconButton, { onClick: handleDrawerClose },
                React.createElement(ChevronLeftIcon, null))
            :
                React.createElement(IconButton, { onClick: handleDrawerOpen },
                    React.createElement(ChevronRightIcon, null)))));
};

var useStyles = makeStyles(function (theme) {
    return createStyles({
        drawerButton: {
            gutters: theme.mixins.gutters()
        },
        buttonIcon: {
            color: theme.palette.primary.main
        }
    });
});
var SidebarItem = function (_a) {
    var icon = _a.icon, link = _a.link, label = _a.label;
    var classes = useStyles();
    return (React.createElement(ListItem, { className: classes.drawerButton, button: true, component: Link, to: link },
        React.createElement(ListItemIcon, null, React.cloneElement(icon, { className: classes.buttonIcon })),
        React.createElement(ListItemText, { primary: label })));
};

var baseTheme = {
    palette: {
        primary: {
            main: "#05707d",
            light: "#86d0c8"
        },
        secondary: {
            main: "#86d0c8",
        },
        text: {}
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
    },
    overrides: {
        MuiTooltip: {
            tooltip: {
                fontSize: "0.8em"
            }
        }
    }
};

var ProcessState;
(function (ProcessState) {
    ProcessState[ProcessState["idle"] = 0] = "idle";
    ProcessState[ProcessState["running"] = 1] = "running";
    ProcessState[ProcessState["success"] = 2] = "success";
    ProcessState[ProcessState["error"] = 3] = "error";
})(ProcessState || (ProcessState = {}));
function Alert(props) {
    return React.createElement(MuiAlert, __assign({ elevation: 6, variant: "filled" }, props));
}
var ProcessStatus = function (_a) {
    var className = _a.className, state = _a.state, setState = _a.setState, loadingMessage = _a.loadingMessage, errorMessage = _a.errorMessage, successMessage = _a.successMessage, useSnackbar = _a.useSnackbar, hideProgressBar = _a.hideProgressBar;
    var getLoadingComponent = function () {
        if (loadingMessage !== undefined) {
            if (useSnackbar)
                return (React.createElement(Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, open: state === ProcessState.running },
                    React.createElement(Alert, { severity: "info" }, loadingMessage)));
            else
                return (React.createElement(MuiAlert, { severity: "info" }, loadingMessage));
        }
    };
    var getSuccessComponent = function () {
        if (successMessage !== undefined) {
            if (useSnackbar)
                return (React.createElement(Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, open: state === ProcessState.success },
                    React.createElement(Alert, { severity: "success", onClose: function () {
                            if (setState)
                                setState(ProcessState.idle);
                        } }, successMessage)));
            else
                return (React.createElement(MuiAlert, { severity: "success" }, successMessage));
        }
    };
    var getErrorComponent = function () {
        if (errorMessage !== undefined) {
            if (useSnackbar)
                return (React.createElement(Snackbar, { anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, open: state === ProcessState.error },
                    React.createElement(Alert, { severity: "error", onClose: function () {
                            if (setState)
                                setState(ProcessState.idle);
                        } }, errorMessage)));
            else
                return (React.createElement(MuiAlert, { severity: "error" }, errorMessage));
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className },
            state === ProcessState.success &&
                getSuccessComponent(),
            state === ProcessState.error &&
                getErrorComponent(),
            state === ProcessState.running && (React.createElement(React.Fragment, null,
                hideProgressBar !== true && React.createElement(LinearProgress, null),
                getLoadingComponent())))));
};

export { Content, EmailInput, FormCheckbox, FormDate, FormTextField$1 as FormNumberField, FormSelect, FormTextArea, FormTextField, NoReadWriteTextField, PHNInput, Page, PaperPage, PhoneInput, PrivateRoute, ProcessState, ProcessStatus, Root, Sidebar, SidebarItem, baseTheme };
